import ApplicationController from "./application_controller";

export default class NavbarController extends ApplicationController {
  static targets = ["expandedNavMenuLink", "expandedNavMenu"];

  declare expandedNavMenuLinkTarget: HTMLElement;
  declare expandedNavMenuTarget: HTMLElement;

  toggleExpandedNavMenu() {
    if (this.expandedNavMenuLinkTarget.classList.contains("is-active")) {
      this.closeExpandedNavMenu();
    } else {
      this.openExpandedNavMenu();
    }
  }

  openExpandedNavMenu() {
    this.expandedNavMenuLinkTarget.classList.add("is-active");
    this.expandedNavMenuTarget.classList.add("is-active");
  }

  closeExpandedNavMenu() {
    this.expandedNavMenuLinkTarget.classList.remove("is-active");
    this.expandedNavMenuTarget.classList.remove("is-active");
  }

  close(event?: MouseEvent) {
    if (event) {
      if (
        this.expandedNavMenuLinkTarget.contains(event.target as HTMLElement) ||
        this.expandedNavMenuTarget.contains(event.target as HTMLElement)
      ) {
        return;
      }
    }

    this.closeExpandedNavMenu();
  }
}
